import { useTranslation } from 'react-i18next';
import { skillAreas } from '@/mocks/skillsData';

const skillImages = [
  '/images/generated/skill-service-2026.jpg',
  '/images/generated/skill-observation-2026.jpg',
  '/images/generated/skill-communication-2026.jpg',
  '/images/generated/skill-management-2026.jpg',
  '/images/generated/skill-crisis-2026.jpg',
];

// Number of skills per area (from mock data)
const SKILL_COUNTS = [5, 4, 5, 5, 5];
const AREA_COUNT = 5;

export default function SkillAreas() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-primary-900">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('skills.intro.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-400 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-50 tracking-[0.06em] mb-2">
            {t('skills.intro.title')}
          </h2>
          {String(t('skills.intro.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-400 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
          {String(t('skills.intro.description')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-300 tracking-[0.04em] leading-relaxed mt-5 max-w-[600px] mx-auto">{__s}</p>))}
        </div>

        <div className="space-y-6">
          {Array.from({ length: AREA_COUNT }, (_, idx) => (
            <div
              key={idx}
              className={`card-glow group flex flex-col md:flex-row gap-0 bg-primary-800/40 border border-primary-700/40 cursor-pointer ${
                idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
              }`}
            >
              <div className="w-full md:w-[320px] flex-shrink-0">
                <img
                  src={skillImages[idx]}
                  alt={t(`skills.area.${idx}.title`)}
                  className="w-full aspect-[4/3] object-cover object-top"
                />
              </div>

              <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
                <div className="flex items-start gap-4 mb-4">
                  <span className="font-heading text-3xl text-accent-500/40 group-hover:text-accent-400/60 transition-colors flex-shrink-0 leading-none mt-1">
                    {skillAreas[idx].number}
                  </span>
                  <div>
                    <h3 className="font-heading text-[16px] md:text-[18px] text-foreground-100 tracking-[0.05em] mb-1 group-hover:text-accent-400 transition-colors">
                      {t(`skills.area.${idx}.title`)}
                    </h3>
                    <p className="section-title-en text-accent-500 text-[13px] tracking-[0.08em]">
                      {t(`skills.area.${idx}.titleEn`)}
                    </p>
                    <p className="text-[14px] text-foreground-400 tracking-[0.04em] mt-1">
                      {t(`skills.area.${idx}.subtitle`)}
                    </p>
                  </div>
                </div>

                <p className="text-[15px] text-foreground-300 tracking-[0.04em] leading-relaxed mb-4">
                  {t(`skills.area.${idx}.description`)}
                </p>

                <div className="mb-4">
                  {String(t('skills.area.skillsLabel')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[13px] text-accent-500 tracking-[0.1em] mb-2 font-label">{__s}</p>))}
                  <ul className="space-y-1">
                    {Array.from({ length: SKILL_COUNTS[idx] }, (_, si) => (
                      <li key={si} className="flex items-start gap-2 text-[14px] text-foreground-400 tracking-[0.03em]">
                        <div className="w-3.5 h-3.5 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-check-line text-accent-500 text-[12px]"></i>
                        </div>
                        {t(`skills.area.${idx}.skill.${si}`)}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="flex flex-wrap items-center gap-x-3 gap-y-2 text-[13px]">
                  <span className="inline-flex items-center gap-3">
                    <span className="text-foreground-500 tracking-[0.04em]">{t('skills.area.startLabel')}</span>
                    <span className="px-2.5 py-1 bg-accent-500/15 text-accent-400 tracking-[0.06em]">
                      {t(`skills.area.${idx}.startCourse`)}
                    </span>
                  </span>
                  {skillAreas[idx].deepenCourse !== skillAreas[idx].startCourse && (
                    <span className="inline-flex items-center gap-3">
                      <span className="text-foreground-600 tracking-[0.04em]">{t('skills.area.deepenLabel')}</span>
                      <span className="px-2.5 py-1 bg-accent-500/10 text-accent-500 tracking-[0.06em]">
                        {t(`skills.area.${idx}.deepenCourse`)}
                      </span>
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
